import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=c5cc4216"
import script from "./task-detail.vue?vue&type=script&lang=js"
export * from "./task-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5cc4216')) {
      api.createRecord('c5cc4216', component.options)
    } else {
      api.reload('c5cc4216', component.options)
    }
    module.hot.accept("./task-detail.vue?vue&type=template&id=c5cc4216", function () {
      api.rerender('c5cc4216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/task-detail.vue"
export default component.exports